import React from "react";
import classNames from "classnames";

const Button = ({
  children,
  onClick,
  className,
  iconSrc,
  iconAlt = "",
  disabled = false,
  type = "button",
  style,
  rounded = "md",
}) => {
  const content = (
    <>
      {iconSrc && (
        <img
          src={iconSrc}
          alt={iconAlt}
          className="object-contain"
          aria-hidden="true"
        />
      )}
      <span>{children}</span>
    </>
  );

  const commonClasses = classNames(
    `rounded-${rounded}`,
    "inline-flex items-center justify-center gap-2 px-6 py-3 transition-all h-9 duration-300 font-medium focus:outline-none",
    !disabled && "cursor-pointer",
    disabled && "opacity-50 cursor-not-allowed pointer-events-none",
    className
  );

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={commonClasses}
      style={style}
    >
      {content}
    </button>
  );
};

export default Button;
